'use client';

import { useTranslation } from 'react-i18next';

import {
  type ResolvedBookingPolicy,
  pickPolicyText,
  policyTextToBullets,
} from '../booking-policy-config';

export function usePackageBookingPolicy(
  policy: ResolvedBookingPolicy | undefined,
  packageId: string | undefined,
) {
  const { t, i18n } = useTranslation('bookings');
  if (!policy?.requireAcceptance) return undefined;

  const cancellationText = pickPolicyText(policy.cancellationPolicy, i18n.language);

  return {
    requireAcceptance: policy.requireAcceptance,
    termsText: pickPolicyText(policy.termsConditions, i18n.language),
    cancellationPolicyItems: cancellationText
      ? policyTextToBullets(cancellationText)
      : [t('policyNonRefundable'), t('policyNonTransferable')],
    purchaseKey: packageId ?? '',
  };
}
